import { getBrandIdentity } from '@utils/getBrandIdentity'

export const storeValues = {
  sial: 'sial',
  b2b: 'b2b',
  mm: 'mm',
}

export const getStore = () => {
  const brandIdentity = getBrandIdentity()
  return brandIdentity === 'MerckMillipore' ? storeValues.mm : storeValues.sial
}
